import axiosInstance from "../axiosConfig";
import Cookies from "js-cookie";

import { logger } from "utils/logger";

export const getCurrentUserData = async (): Promise<{
  organization_name: string;
  first_name: string;
  last_name: string;
  email: string;
  referral_token: string;
  verification_code: string;
  inn?: string;
  registration_number?: string;
  certificate_serial_number?: string;
  certificate_owner_full_name?: string;
  certificate_valid_from?: string | null;
  certificate_valid_to?: string | null;
}> => {
  const userId = Number(Cookies.get("user_id"));
  if (!userId) throw new Error("User ID not found in cookies");
  const response = await axiosInstance.get(`/users/${userId}/`, { params: { _t: Date.now() } });
  return response.data;
};

export const getUserData = async (userId: number): Promise<{
  organization_name: string;
  first_name: string;
  last_name: string;
  email: string;
  referral_token: string;
  verification_code: string;
  inn?: string;
  registration_number?: string;
  certificate_serial_number?: string;
  certificate_owner_full_name?: string;
  certificate_valid_from?: string | null;
  certificate_valid_to?: string | null;
}> => {
  try {
    const response = await axiosInstance.get(`/users/${userId}/`);
    return response.data;
  } catch (error) {
    logger.error("Ошибка при запросе данных пользователя:", error);
    throw error;
  }
};

export const updateUserData = async (
  userId: number,
  data: {
    organization_name?: string;
    first_name?: string;
    last_name?: string;
    email?: string;
    verification_code?: string;
    inn?: string;
    registration_number?: string;
    certificate_serial_number?: string;
    certificate_owner_full_name?: string;
    certificate_valid_from?: string | null;
    certificate_valid_to?: string | null;
  },
): Promise<void> => {
  try {
    await axiosInstance.patch(`/users/${userId}/`, data);
  } catch (error) {
    logger.error("Ошибка при обновлении данных пользователя:", error);
    throw error;
  }
};

export interface TeacherMarketingDocument {
  id: number;
  title: string;
  version: string;
  url: string;
  required: boolean;
  scope: string;
  accepted: boolean;
}

export interface TeacherMarketingConsentState {
  configuration_complete: boolean;
  documents: TeacherMarketingDocument[];
}

export const getTeacherMarketingConsent = async (): Promise<TeacherMarketingConsentState> => {
  const response = await axiosInstance.get("/users/marketing-consent/");
  return response.data;
};

export const setTeacherMarketingConsent = async (
  documentId: number,
  enabled: boolean,
): Promise<void> => {
  await axiosInstance.post("/users/marketing-consent/", {
    document_id: documentId,
    enabled,
  });
};

export const getBotConfig = async (
  userId: number,
): Promise<
  {
    id: number;
    user: number;
    bot_token: string;
    tech_support_tg_name: string;
  }[]
> => {
  try {
    const response = await axiosInstance.get(`/bot_config/?user_id=${userId}`);
    return response.data;
  } catch (error) {
    logger.error("Ошибка при запросе настроек бота:", error);
    throw error;
  }
};

export const createBotConfig = async (data: {
  user: number;
  bot_token: string;
  tech_support_tg_name: string;
}): Promise<{ id: number }> => {
  try {
    const botId = `bot_${data.bot_token.substring(0, 10)}`;
    const response = await axiosInstance.post(`/bot_config/`, { ...data, bot_id: botId });
    return response.data;
  } catch (error) {
    logger.error("Ошибка при создании настроек бота:", error);
    throw error;
  }
};

export const updateBotConfig = async (
  botConfigId: number,
  userId: number,
  data: { bot_token?: string; tech_support_tg_name?: string },
): Promise<void> => {
  try {
    await axiosInstance.patch(`/bot_config/${botConfigId}/?user_id=${userId}`, data);
  } catch (error) {
    logger.error("Ошибка при обновлении настроек бота:", error);
    throw error;
  }
};

export const deleteBotConfig = async (botConfigId: number): Promise<void> => {
  try {
    await axiosInstance.delete(`/bot_config/${botConfigId}/`);
  } catch (error) {
    logger.error("Ошибка при удалении настроек бота:", error);
    throw error;
  }
};

export const restartBot = async (botConfigId: number): Promise<void> => {
  try {
    await axiosInstance.post(`/bot_config/${botConfigId}/restart/`);
  } catch (error) {
    logger.error("Ошибка при перезапуске бота:", error);
    throw error;
  }
};

export const getPublicCatalogLink = async (): Promise<{ slug: string; url: string }> => {
  try {
    const response = await axiosInstance.get(`/courses/teacher/public-catalog-link/`);
    return response.data;
  } catch (error) {
    logger.error("Ошибка при получении личной ссылки преподавателя:", error);
    throw error;
  }
};
